import { Component, OnInit, Output, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { EmitterService } from '../services/emitter.service';
import { UserDetailsService } from '../services/user-details.service';
import { Utility } from '../shared/utility/utility';
import * as _ from 'underscore';
import { environment } from '../../environments/environment';
import { HostedCashierPaymentsService } from '../services/hosted-cashier-payments.service';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AjaxService } from '../services/ajax.service';
import { PnpZimplerService } from '../services/pnp-zimpler.service';
@Component({
  selector: 'app-app-cashier',
  templateUrl: './app-cashier.component.html',
  styleUrls: ['./app-cashier.component.scss']
})
export class AppCashierComponent implements OnInit, OnDestroy {
  isVerified: boolean;
  isVerifiedSkelton: boolean = true;
  isInitiated;
  isNew;
  isKycBlocked;
  isConfirmId: boolean = false;
  isPendingWithdrawals: boolean = false;
  isCompleteProfile;
  isCompleteUser;
  langCode;
  isRealUser: boolean;
  userDetail;
  pendingWithDrawsAvailable = 0;
  cashBalance;
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaUrlPath = environment.mediaPath;
  showInitiatedOrVerifiedComponent = false;
  @Output() callingFrom;
  piqObject = {};
  isCashierSlider: boolean = false;
  isCashierPage = false;

  // @Output() triggerAccountMenu = new EventEmitter<{}>();
  isCountryAllowed: any;
  destroy$: Subject<boolean> = new Subject<boolean>();



  constructor(
    private paymentService: HostedCashierPaymentsService,
    private router: Router,
    private emitterService: EmitterService,
    private userDetailsService: UserDetailsService,
    private utils: Utility,
    private activatedRoute: ActivatedRoute,
    private ajaxService:AjaxService,
    private pnpService: PnpZimplerService
  ) {
    this.userDetailsService.userBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(message=>{
      this.cashBalance = this.userDetailsService.getUserCashBalance();
      this.checkPendingWithdrawals();
    });

    this.emitterService.isCountryAllowed$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isCountryAllowed = data;
    })
    
    if (window.location.href.indexOf("page=") >= 0) {
      this.router.navigate([], { queryParams: { page: null }, queryParamsHandling: 'merge' });
    }
  }

  ngOnInit() {
    this.langCode = localStorage.getItem('langCode');
    this.emitterService.broadcastActiveTabChangeSource("cashier");
    this.cashBalance = this.userDetailsService.getUserCashBalance();    
    this.checkPendingWithdrawals();
    this.isCountryAllowed = this.emitterService.getIsCountryAllowed()
  }


  // Check Pending Withdrawals
  checkPendingWithdrawals() {
    const getTokenObservable = this.paymentService.getTokenPaymentIQ('cashier');
    const getProfileDataObservable = this.ajaxService.getProfileBalanceCurrency(true);

    combineLatest([getTokenObservable, getProfileDataObservable]).pipe(takeUntil(this.destroy$)).subscribe(async ([tokenData, profileData]:any) => {

      if (profileData && profileData.profile && profileData.profile.playerID) {
        this.userDetailsService.setUserCountry(profileData["countryCode"]);
        this.isRealUser = profileData && profileData.profile.userStatus === "real" ? true : false;
        this.cashBalance = profileData && profileData.profile.balanceDetails ? profileData.profile.balanceDetails.cash : 0;

        this.isVerifiedSkelton = false;

        this.piqObject['userId'] = profileData.profile.playerID;
        this.piqObject['sessionId'] = tokenData.token;
        this.piqObject['merchantId'] = environment.paymentIqMID;

        const getPendingWithdrawalObject = _.clone(this.piqObject);
        getPendingWithdrawalObject['method'] = 'Withdrawal';
        getPendingWithdrawalObject['states'] = 'WAITING_APPROVAL';
        let pendingWithDrawlsData:any;
        if(this.isCountryAllowed===1 || this.userDetailsService.checkIsPNPUser()){
          let pendingWithdrawalObject = {
            cashoutVerifiedtxnRequired: true
          }
          this.pnpService.getPendingCashOuts(pendingWithdrawalObject).then(data=>{
            pendingWithDrawlsData = data;
            this.pendingWithDrawsAvailable = pendingWithDrawlsData.length
          })
        } else if(this.isCountryAllowed===2){
          pendingWithDrawlsData = await this.paymentService.getPendingWithdrawal(getPendingWithdrawalObject).toPromise();
          if (pendingWithDrawlsData && pendingWithDrawlsData.success && (pendingWithDrawlsData.transactions && pendingWithDrawlsData.transactions.length > 0)) {
            this.pendingWithDrawsAvailable = pendingWithDrawlsData.transactions.length;
          } else {
            this.pendingWithDrawsAvailable = 0;
          }
        }

        this.isCashierPage=true;
      }

    });

  }

  deposit() {
    if(!this.userDetailsService.checkIsPNPUser()){
      this.emitterService.broadcastModalState({ name: "paymentModal", state: "open", cashierType: "deposit" });
    } else {
      this.pnpService.openZimplerDeposit()
    }
  }

  withdraw() {
    if (!this.userDetailsService.checkIsPNPUser()) {
      this.emitterService.broadcastModalState({ name: "paymentModal", state: "open", cashierType: "withdrawal" });
    } else {
      this.pnpService.openZimplerWithDraw();
    }
    this.goBack()
  }

  navigiateToPendingWithdrawls(modalId) {
    this.emitterService.broadcastModalState({ name: "pendingwithdrawl", state: "open" });
    this.goBack()
  }



  openModal(modalId) {
    this.isPendingWithdrawals = true;
    this.utils.openModal(modalId);
    this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: { page: modalId }, queryParamsHandling: "merge", });
  }

  closeModal(modalId) {
    this.utils.closeModal(modalId);
    if (modalId === 'pendingwithdrawal') {
      this.isPendingWithdrawals = false;
    }
    this.router.navigate([], { queryParams: { page: null }, queryParamsHandling: 'merge' });
  }

  completeprofileCall() {
    this.goBack();
    this.utils.goToCompleteProfile();
  }
  
  goBack(){
    this.emitterService.broadCastToggleNavPanel({isBack:true, opened:true});
    this.utils.setIsSideMenuOpened(true);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
